import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../api/api.ts";

export const useGetAllStats = () => {
  return useQuery({
    queryKey: ["allStats"],
    queryFn: async () => {
      const response = await apiClient.get("/admin/stats");

      return response.data;
    },
    refetchIntervalInBackground: true,
  });
};
